import React from 'react';

const WidePageContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div className="wide-page-container" style={{ 
            width: '95%', 
            maxWidth: 'none', 
            margin: 'auto', 
            padding: '20px 40px' 
        }}>
            {children}
        </div>
    );
};

export default WidePageContainer;